/**
 * Libellés métier UI pour la classification canal / retrait analytics.
 * Aligné sur classifyCanalMetier (backend) — SITE n’est pas un canal orthogonal.
 */

export const CANAL_METIER_UI_LABELS = {
  POS: 'Caisse (POS)',
  LIVRAISON: 'Livraison',
  CLICK_COLLECT: 'Click & collect',
  EXPEDITION: 'Expédition',
  DIGITAL: 'Digital (cartes cadeaux)',
  /** Fallback : canal WEB sans mode de retrait typé (≠ « tout le site web »). */
  SITE: 'Web — retrait non précisé',
  APP: 'Application',
};

/** Ancien libellé API preprod encore en circulation. */
const LEGACY_SITE_LABELS = new Set(['Site web', 'SITE WEB', 'SITE']);

/**
 * @param {{ key?: string, label?: string }} row
 * @returns {string}
 */
export function resolveCanalMetierLabel(row = {}) {
  const key = String(row.key || '').toUpperCase();
  if (key && CANAL_METIER_UI_LABELS[key]) {
    return CANAL_METIER_UI_LABELS[key];
  }
  const label = String(row.label || '').trim();
  if (LEGACY_SITE_LABELS.has(label) || label.toLowerCase() === 'site web') {
    return CANAL_METIER_UI_LABELS.SITE;
  }
  return label || key || '—';
}

/**
 * @param {Array<{ key?: string, label?: string }>} rows
 */
export function mapCanauxMetierUiLabels(rows = []) {
  return (rows || []).map((row) => ({
    ...row,
    label: resolveCanalMetierLabel(row),
  }));
}

export const SITE_WEB_SEMANTICS_HINT =
  '« Web — retrait non précisé » = commande payée qui n’est ni Click & Collect, ni Livraison, ni Expédition, ni Caisse POS, ni App : souvent canal WEB sans mode de retrait renseigné (fallback). Ce n’est pas « toutes les commandes du site » — C&C, livraison et expédition passent aussi souvent par le site.';
